<template>
<div class="no1">
  <div class="no11">
    <slot name="queryleft"></slot>
  </div>
  <div>
    <slot name="querycenter"></slot>
  </div>
  <div class="no12">
    <slot name="queryright"></slot>
  </div>
</div>
</template>

<script>
export default {}
</script>

<style lang="less">
.no1 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 5px;
  font-size: 14px;
  align-items: center;

  .no11 {
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: left;

    .querylabel {
      color: #555;
    }

    div {
      padding: 0 3px 0px 0px;
    }
  }

  .no12 {
    display: flex;
    flex-direction: row;
    align-items: center;

    .querylabel {
      color: #555;
    }

    // div {
    //   padding: 0 5px;
    // }
  }
}
</style>
